<template>
<div class="container" :style="{ height: currentHeight }">
    <div class="topContainer"></div>
    <div class="recentContainer">
      <RecentTypeView></RecentTypeView>
      <div class="rightContainer">
        <div class="topTitle">{{ titleStr }}</div>
        <div v-show="curSelectRecentType === 1">
          <RecentFileView></RecentFileView>
        </div>
        <div v-show="curSelectRecentType === 2">
          <RecentMineView></RecentMineView>
        </div>
        <div v-show="curSelectRecentType === 3">
          <RecentKBView></RecentKBView>
        </div>
        <div v-show="curSelectRecentType === 4">
          <RecentStarView></RecentStarView>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import RecentFileView from "@/pages/H5/Cloud/components/hoverDir/RecentFileView.vue";
import RecentMineView from "@/pages/H5/Cloud/components/hoverDir/RecentMineView.vue";
import RecentKBView from "@/pages/H5/Cloud/components/hoverDir/RecentKBView.vue";
import RecentTypeView from "@/pages/H5/Cloud/components/hoverDir/RecentTypeView.vue";
import { mapActions, mapState } from "vuex";
import RecentStarView from "@/pages/H5/Cloud/components/hoverDir/RecentStarView.vue";
export default {
  name: "HoverContainerView",
  components: {
    RecentFileView,
    RecentMineView,
    RecentKBView,
    RecentTypeView,
    RecentStarView
  },
  data() {
    return {
      titleStr: intl.$t("最近使用#!!!#src/pages/H5/Cloud/components/hoverDir/HoverContainerView.vue_1"),
      currentHeight: "500px"
    };
  },
  created() {
    this.setCurrentFileId(this.currentFileId);
  },
  computed: {
    ...mapState({
      curSelectRecentType: (state) => state.curSelectRecentType,
      currentFilePage: (state) => state.currentFilePage,
      currentMinePage: (state) => state.currentMinePage,
      currentKBPage: (state) => state.currentKBPage,
      currentStarPage: (state) => state.currentStarPage
    })
  },
  watch: {
    curSelectRecentType(newVal, oldVal) {
      if (newVal === 1) {
        this.titleStr = intl.$t("最近使用#!!!#src/pages/H5/Cloud/components/hoverDir/HoverContainerView.vue_2");
      } else if (newVal === 2) {
        this.titleStr = intl.$t("我的文档#!!!#src/pages/H5/Cloud/components/hoverDir/HoverContainerView.vue_1");
      } else if (newVal === 4) {
        this.titleStr = intl.$t("收藏#!!!#src/pages/H5/Cloud/components/hoverDir/HoverContainerView.vue_1");
      } else {
        this.titleStr = intl.$t("全部知识库#!!!#src/pages/H5/Cloud/components/hoverDir/HoverContainerView.vue_1");
      }
      this.updateContainerHeight();
    },
    currentFilePage(newVal, oldVal) {
      this.updateContainerHeight();
    },
    currentMinePage(newVal, oldVal) {
      this.updateContainerHeight();
    },
    currentKBPage(newVal, oldVal) {
      this.updateContainerHeight();
    },
    currentStarPage(newVal, oldVal) {
      this.updateContainerHeight();
    },
    currentFileId(newVal, oldVal) {
      this.setCurrentFileId(newVal);
    }
  },
  methods: {
    ...mapActions({
      setCurrentFileId: "setCurrentFileId"
    }),
    goToHomePage() {
      let baseURL = process.env.VUE_APP_WIKI_URL;
      window.open(`https:${baseURL}`, "_blank");
    },
    updateContainerHeight() {
      if (this.curSelectRecentType === 1) {
        //file
        if (this.currentFilePage > 10) {
          this.currentHeight = "600px";
        } else {
          this.currentHeight = "500px";
        }
      } else if (this.curSelectRecentType === 2) {
        //star
        if (this.currentMinePage > 10) {
          this.currentHeight = "600px";
        } else {
          this.currentHeight = "500px";
        }
      } else if (this.curSelectRecentType === 4) {
        //star
        if (this.currentStarPage > 10) {
          this.currentHeight = "600px";
        } else {
          this.currentHeight = "500px";
        }
      } else {
        //kb
        if (this.currentKBPage > 10) {
          this.currentHeight = "600px";
        } else {
          this.currentHeight = "500px";
        }
      }
      //   console.log("curSelectRecentType", this.curSelectRecentType);
      //   console.log("currentFilePage", this.currentFilePage);
      //   console.log("currentMinePage", this.currentMinePage);
      //   console.log("currentKBPage", this.currentKBPage);
      //   console.log("currentHeight", this.currentHeight);
    },
    setRecentVisible(value) {

      //   console.log("set-visible", value);
    } }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 467px !important;
  min-height: 470px;
  background: transparent;
  transition: height 0.3s ease-out;
  // overflow: hidden; //修复容器右侧阴影不显示问题
  margin-top: 60px;
  margin-left: -38px;

  .topContainer {
    height: 12px;
    width: 100%;
    background-color: transparent;
  }

  .recentContainer {
    display: flex;
    height: calc(100% - 24px);
    background-color: #fff;
    border: 1px solid #e6e8ec;
    box-shadow: 0 8px 12px 0 #1213171a;
    border-radius: 8px;
    overflow: hidden;

    .rightContainer {
      width: 100%;
      display: flex;
      flex-direction: column;

      .topTitle {
        padding-left: 19px;
        height: 41px;
        line-height: 41px;
        width: 100%;
        color: #222329;
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
}

.container-enter-active,
.container-leave-active {
  transition: height 0.3s ease-out;
}

.container-enter,
.container-leave-to {
  height: 510px;
}

.container-leave-active {
  height: 510px;
}
</style>
